export default function Table({ columns, data }) {
  if (columns == null || data == null) {
    return <div>Empty</div>;
  }

  return (
    <table className=" w-full overflow-x-auto text-left text-sm text-gray-500 dark:text-gray-400 rtl:text-right">
      <thead className="bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
        <tr>
          {columns.map((column) => (
            <th scope="col" className="px-6 py-3">
              {column.name}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((data, index) => (
          <tr>
            {columns.map((column, index) => (
              <td
                scope="row"
                className="whitespace-nowrap px-6 py-4 font-medium text-gray-900 dark:text-white"
              >
                {getCellType(column, data)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function getCellType(column, data) {
  if (column.type == "boolean") {
    return (
      <input
        type="checkbox"
        name={column.key}
        checked={data[column.key] ? "checked" : ""}
        className="form-checkbox h-5 w-5 text-blue-600 dark:border-gray-600 dark:bg-gray-700 "
      />
    );
  } else if (column.type == "date") {
    try {
      let date = new Date(
        data[column.key][0],
        data[column.key][1] - 1,
        data[column.key][2],
        data[column.key][3],
        data[column.key][4],
        data[column.key][5],
        data[column.key][6],
      );
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    } catch (e) {
      return "Invalid Date";
    }
  } else if (column.type == "button") {
    return (
      <button
        onClick={() => column.onClick(data)}
        className="flex items-center rounded bg-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-opacity-75"
      >
        {column.name}
      </button>
    );
  } else if (column.type == "dynamic") {
    return column.content(data);
  } else {
    return data[column.key];
  }
}
